export const enum VariableControl {
    Radio = "radio",
    Select = "select",
    Autocomplete = "autocomplete",
    Textarea = "textarea"
}
